import styled from 'styled-components';

import { Button, RadiusConfig } from 'enable-ui';

import { SubmitButton } from 'modules/dashboard/styles/dashboard';

import { COLOR, COLOR_CONFIG } from 'constants/color';

export const SelectEventType = styled.div<{
  borderColor?: string;
  color?: string;
  backgroundColor?: string;
  disabled?: boolean;
}>`
  .es-input-master-wrapper {
    .dropdown-children {
      div {
        border-radius: 12px;
        min-height: 28px;
        background-color: ${({ backgroundColor }) => backgroundColor};
        border: 1px solid ${({ borderColor }) => borderColor};
        max-width: 125px;
        width: 100% !important;

        cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
        opacity: ${({ disabled }) => (disabled ? 0.6 : 1)};
        padding: 0 6px 0 9px;

        .value-select {
          color: ${({ color }) => color};
        }

        .icon {
          border: none;
          padding: 0;
          margin-left: 4px;

          svg path {
            stroke: ${({ color }) => color};
          }
        }
      }
    }
  }

  .dropdown {
    background: ${COLOR_CONFIG.white};

    .dropdown-item {
      background: ${COLOR_CONFIG.white};

      &:hover {
        background: ${COLOR.neutral['neutral-4']};
      }
    }

    .selected {
      svg path {
        stroke: ${COLOR.primary['primary-6']};
      }
    }
  }
`;

export const NameInput = styled.div`
  width: 100%;

  .es-input-master-wrapper {
    border-bottom: 1px solid ${COLOR.neutralTrans['neutralTrans-25']} !important;
  }

  .text-input-wrapper {
    border: none !important;
  }

  .text-input {
    padding: 0px !important;
    font-size: 18px !important;
    line-height: 26px !important;
    font-weight: 600 !important;
  }
`;

export const CustomCalendarInput = styled.div`
  .es-calendar-content {
    max-width: 128px;
    min-width: 128px;
    width: 100%;
    padding: 11px 35px 11px 16px;

    background-color: ${COLOR_CONFIG.white};
    border-radius: ${RadiusConfig.sm}px;

    svg {
      display: none;
    }
    p {
      white-space: nowrap;
      margin-left: 0px !important;
      margin-top: 0px !important;
      font-size: 16px;
      line-height: 22px;
      color: ${COLOR.surfaceNeutralBold['neutral-11']};
    }
  }
`;

export const RecurringSelect = styled.div`
  margin-left: 40px;
  margin-top: -12px;

  .es-input-master-wrapper {
    .dropdown-children {
      div {
        width: 200px !important;
        border-radius: 12px;
        background-color: ${COLOR_CONFIG.white};
      }

      .icon {
        justify-content: flex-end;
        margin: 0 9px 0 0;
      }
    }
  }

  .dropdown {
    background: ${COLOR_CONFIG.white};

    .dropdown-item {
      background: ${COLOR_CONFIG.white};

      &:hover {
        background: ${COLOR.neutral['neutral-4']};
      }
    }

    .selected {
      svg path {
        stroke: ${COLOR.primary['primary-6']};
      }
    }
  }

  .value-select {
    font-size: 16px;
    line-height: 22px;
    color: ${COLOR.surfaceNeutralBold['neutral-11']};
  }
`;

export const CustomFileUpload = styled.div`
  width: 100%;

  .es-file-upload {
    width: 100%;
    background-color: ${COLOR_CONFIG.white};
    border-radius: ${RadiusConfig.sm}px;

    p {
      font-size: 16px;
      line-height: 22px;
      color: ${COLOR_CONFIG['neutral-text']};
      font-weight: 400;
    }
  }

  svg {
    path {
      stroke: ${COLOR_CONFIG['neutral-text']} !important;
    }
  }

  img {
    border-radius: ${RadiusConfig.sm}px;
  }
`;

export const EndRepeatModalContainer = styled.div`
  .es-modal {
    background: ${COLOR_CONFIG.white} !important;
    border-radius: ${RadiusConfig.sm}px;
  }

  .es-calendar-content {
    min-width: 150px;
    width: 170px;
    background-color: ${COLOR_CONFIG.white};
  }

  .es-input-master-wrapper {
    width: auto;
  }

  .es-modal-body {
    padding: 13px 24px 8px;
  }

  .es-modal-footer {
    button {
      border-radius: ${RadiusConfig.sm}px;
    }

    button[variant='outlined'] {
      background: ${COLOR_CONFIG.white};
    }
  }

  .border-radio {
    font-size: 16px;
    line-height: calc(22 / 16);
    color: ${COLOR.surfaceNeutralBold['neutral-11']};
  }
`;

export const ButtonCreate = styled(Button)`
  margin-left: 8px;
  font-size: 16px;
  line-height: 22px;
  font-weight: 600;
  height: 44px;
  padding: 0 16px;
  background-color: ${COLOR.primary['primary-6']};
  border-radius: 12px;
  border: none;
  color: ${COLOR_CONFIG.white};
  cursor: pointer;

  &:disabled {
    background: rgba(0, 0, 0, 0.03);
    color: rgba(0, 0, 0, 0.25);
    font-weight: 600;
    cursor: not-allowed;
  }
`;

export const FooterContainer = styled.div`
  padding: 16px 24px 24px;
  display: flex;
  gap: 12px;
  justify-content: flex-end;
`;

export const DeleteButton = styled(SubmitButton)`
  background-color: ${COLOR_CONFIG.red};

  &:hover {
    background-color: rgb(207, 19, 34);
    color: rgb(255, 253, 247);
  }
`;

export const GenerateQRButton = styled(Button)`
  background-color: ${COLOR_CONFIG.white};
  border-radius: 12px;
  border: 1px solid ${COLOR.purpel['purpel-6']};
  color: ${COLOR.purpel['purpel-6']};
  cursor: pointer;
  padding: 4px 12px 4px 13px;
  max-height: 30px;
  margin-left: 8px;
  font-weight: 600;

  svg {
    margin-right: 7px;

    path {
      stroke: ${COLOR.purpel['purpel-6']} !important;
    }
  }

  &:hover {
    color: ${COLOR.purpel['purpel-6']};
    background-color: ${COLOR_CONFIG.white};
  }
`;

export const ViewQRButton = styled(GenerateQRButton)`
  border: 1px solid ${COLOR.neutralTrans['neutralTrans-25']};
  color: ${COLOR.surfaceNeutralBold['neutral-11']};

  svg {
    margin-right: 7px;

    path {
      stroke: ${COLOR.surfaceNeutralBold['neutral-11']} !important;
    }
  }

  &:hover {
    color: ${COLOR.surfaceNeutralBold['neutral-11']};
  }
`;

export const ModalContainer = styled.div`
  .es-modal {
    background: ${COLOR_CONFIG.white};
  }

  .es-modal-body {
    padding: 13px 24px 24px;
  }
`;

export const QRCodeContainer = styled.div`
  border: 8px solid #f0f0f0;
  border-radius: 32px;
  max-height: 240px;
  height: 100%;
  margin: 32px auto 48px;
  max-width: 240px;
  width: 100%;
  padding: 24px;

  canvas {
    height: auto;
    max-width: 100%;
  }
`;

export const ButtonDownloadContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const ButtonDownload = styled(Button)`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 12px 24px;
  border-radius: ${RadiusConfig.sm}px;
  cursor: pointer;
  background-color: ${COLOR.primary['primary-6']};
  font-size: 16px;
  line-height: 22px;
  font-weight: 600;
  color: ${COLOR_CONFIG.white};
  border: none;

  svg {
    path {
      stroke: ${COLOR_CONFIG.white} !important;
    }
  }

  &:hover {
    background-color: ${COLOR.primary['primary-6']};
    color: ${COLOR_CONFIG.white};
  }
`;
